import { t } from "i18next"

export function getBasePopup(): any {
    return {
        "page": {
            "body": {
                "container": {
                    "style": {
                        "background-color": "#FFFFFF"
                    }
                },
                "content": {
                    "computedStyle": {
                        "linkColor": "#0068A5",
                        "messageBackgroundColor": "transparent",
                        "messageWidth": "500px",
                        "messageWidthMobile": "250px"
                    },
                    "style": {
                        "color": "#000000",
                        "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                    }
                },
                "type": "mailup-bee-page-properties",
                "webFonts": [
                    {
                        "fontFamily": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                        "name": "Montserrat",
                        "url": "https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400;700;900&display=swap"
                    }
                ]
            },
            "description": "",
            "rows": [
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "mobileStyle": {
                                "padding-bottom": "20px",
                                "padding-left": "20px",
                                "padding-right": "20px",
                                "padding-top": "20px"
                            },
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "heading": {
                                            "style": {
                                                "color": "#004a6b",
                                                "direction": "ltr",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "font-size": "55px",
                                                "font-weight": "700",
                                                "letter-spacing": "0px",
                                                "line-height": "120%",
                                                "link-color": "#004a6b",
                                                "text-align": "center"
                                            },
                                            "text": "Complete <br/>the look",
                                            "title": "h1"
                                        },
                                        "mobileStyle": {
                                            "font-size": "32px",
                                            "padding-bottom": "10px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        },
                                        "style": {
                                            "padding-bottom": "20px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-heading",
                                    "uuid": "fc0493e5-8178-4179-9d1b-fef1e81e9460"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "heading": {
                                            "style": {
                                                "color": "#305770",
                                                "direction": "ltr",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "font-size": "30px",
                                                "font-weight": "400",
                                                "letter-spacing": "0px",
                                                "line-height": "120%",
                                                "link-color": "#305770",
                                                "text-align": "center"
                                            },
                                            "text": "Add these shoes to get <br/><strong>%10 off </strong>your order",
                                            "title": "h2"
                                        },
                                        "mobileStyle": {
                                            "font-size": "26px",
                                            "padding-bottom": "15px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        },
                                        "style": {
                                            "padding-bottom": "20px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-heading",
                                    "uuid": "701d3de8-6aa9-4fa7-a5dd-ac0d6f6cd35b"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center autowidth",
                                            "hideContentOnMobile": false,
                                            "width": "440px"
                                        },
                                        "image": {
                                            "alt": "",
                                            "height": "567px",
                                            "href": "",
                                            "prefix": "",
                                            "src": "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo003/b5736b5d-2500-4d4e-b628-eecffbd78101/popup/sneakers.png",
                                            "target": "_blank",
                                            "width": "780px"
                                        },
                                        "style": {
                                            "border-radius": "0px",
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "ace224a5-3976-4280-8cdf-5ad961ab22c8"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"\" data-mce-style=\"\"><p style=\"word-break:break-word;\" data-mce-style=\"word-break:break-word;\">ADD TO CART</p></div>",
                                            "percWidth": 100,
                                            "style": {
                                                "background-color": "#004a6b",
                                                "border-bottom": "0px solid transparent",
                                                "border-left": "0px solid transparent",
                                                "border-radius": "4px",
                                                "border-right": "0px solid transparent",
                                                "border-top": "0px solid transparent",
                                                "color": "#ffffff",
                                                "direction": "ltr",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "font-size": "25px",
                                                "font-weight": "700",
                                                "letter-spacing": "0px",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "10px",
                                                "padding-right": "10px",
                                                "padding-top": "5px",
                                                "width": "100%"
                                            },
                                            "target": "_blank"
                                        },
                                        "computedStyle": {
                                            "height": 60,
                                            "hideContentOnMobile": false,
                                            "width": 440
                                        },
                                        "hoverStyle": {
                                            "background-color": "#013950",
                                            "border-bottom": "0px solid transparent",
                                            "border-left": "0px solid transparent",
                                            "border-right": "0px solid transparent",
                                            "border-top": "0px solid transparent",
                                            "color": "#fff"
                                        },
                                        "mobileStyle": {
                                            "font-size": "20px",
                                            "width": "100%"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "20px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "b5ea76b5-3ddf-4c5b-93bb-8d261c3c7bc9"
                                }
                            ],
                            "style": {
                                "background-color": "#e6f0f4",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "30px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "20px"
                            },
                            "uuid": "fc5b4a1e-56b5-4798-a099-2b353a50caeb"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "columnsBorderRadius": "4px",
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "500px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "one-column-empty",
                    "uuid": "64469c38-cc95-4904-9b89-05f83f361fba"
                }
            ],
            "template": {
                "name": "template-base",
                "type": "basic",
                "version": "2.0.0"
            },
            "title": ""
        },
        "comments": {}
    }
}